// extracted by mini-css-extract-plugin
export default {"searchbar_box":"Searchbar_searchbar_box__N9YI2","searchbar_bg":"Searchbar_searchbar_bg__RhEBW"};